import { environment } from './../../../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DynamicTableCreateWidgetM } from '../../models/dynamic-table/dynamic-table-create-widget.model';
import { DynamicTableWidgetDetailsM } from '../../models/dynamic-table/dynamic-table-widget-details.model';
import { DynamicTableWidgetTypesM } from '../../models/dynamic-table/dynamic-table-widget-types.model';
import { DynamicTableModuleWidgetM, DynamicTableModuleListM } from '../../models/dynamic-table/dynamic-table-module-widget.model';
import { HttpService } from './../http.service';

@Injectable({
    providedIn: 'root'
})
export class DynamicTableWidgetService {

    private dynamicTableUrl: string = environment.dynamicTableAPI;

    constructor(
        private httpService: HttpService
    ){}

    createWidget(widgetData: DynamicTableCreateWidgetM): Observable<DynamicTableCreateWidgetM> {
        const api = `${this.dynamicTableUrl}Widget`;
        return this.httpService.post(api,widgetData);
    }

    updateWidget(widgetData: DynamicTableCreateWidgetM, widgetId: number): Observable<DynamicTableCreateWidgetM> {
        const api = `${this.dynamicTableUrl}Widget/${widgetId}`;
        return this.httpService.put(api,widgetData);
    }


    getWidgets(moduleId: number, channelId: number): Observable<DynamicTableWidgetDetailsM[]>{
        const api = `${this.dynamicTableUrl}Widget/ModuleId/${moduleId}/ChannelId/${channelId}`;
        return this.httpService.getAll(api);
    }

    getAddedWidgets(referenceTypeId: number, referenceId: number): Observable<DynamicTableWidgetDetailsM[]>{
        const api = `${this.dynamicTableUrl}Widget/ReferenceTypeId/${referenceTypeId}/ReferenceId/${referenceId}`;
        return this.httpService.getById(api);
    }

    getWidgetTypes(): Observable<DynamicTableWidgetTypesM[]>{
        const api = `${this.dynamicTableUrl}WidgetType`;
        return this.httpService.getAll(api);
    }

    deleteWidget(widgetId: number): Observable<DynamicTableWidgetDetailsM>{
        const api = `${this.dynamicTableUrl}Widget/${widgetId}`;
        return this.httpService.delete(api);
    }

    getModuleWidgets(): Observable<DynamicTableModuleWidgetM[]>{
        const api = `${this.dynamicTableUrl}Widget/ModuleWidgets`;
        return this.httpService.getAll(api);
    }

    getModuleList(): Observable<DynamicTableModuleListM[]>{
        const api = `${this.dynamicTableUrl}Widget/Modules`;
        return this.httpService.getAll(api);
    }
    
}
